// extracted by mini-css-extract-plugin
module.exports = {"modalLapsedUser":"styles_modalLapsedUser__3CV4R"};